import { DateTime } from "luxon";
import type { Frequency } from "../../../../../../../../utils/enums";
import { getMinsFromFrequency } from "../../../../../../../../utils/frequencyHelpers";

export function getHourRangeString(
  firstDate: DateTime,
  lastDate: DateTime,
  frequency: Frequency
) {
  const frequencyInMinutes = getMinsFromFrequency(frequency);
  const newLastDate = lastDate.plus({ minutes: frequencyInMinutes });
  return `${firstDate.toLocaleString(DateTime.TIME_SIMPLE)} - ${newLastDate.toLocaleString(DateTime.TIME_SIMPLE)}`;
}
